import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {LoginUser} from "../../../login-users/shared/login-user.model";
import {User} from "../../../login-users/shared/user/user.model";

export interface UserAuthentication {
    authenticated: boolean;
    authenticatedUser: User;
}

@Injectable({providedIn: 'root'})
export class AuthApiService {
    private readonly apiUrl = '/api/auth';
    private http: HttpClient = inject(HttpClient);

    getLoggedInUser(): Observable<UserAuthentication> {
        return this.http.get<UserAuthentication>(`${this.apiUrl}/current`)
    }

    login(username: string, password: string): Observable<any> {
        const body = new HttpParams()
            .set('username', username)
            .set('password', password);

        return this.http.post(`${this.apiUrl}/login`, body.toString(), {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        });
    }

    logout(): Observable<Object> {
        return this.http.post(`${this.apiUrl}/logout`, {})
            .pipe(tap(() => {
                this.http.get('/api/csrfToken').subscribe();
            }));
    }
}
